/**
 * Icon variant mapping for TabsView icons.
 * Used to apply correct CSS (outline = stroke only, filled = stroke + fill).
 * - outline: stroke-only icons (clock/history, wallet, person, star, etc.)
 * - filled: icons that should use fill color (add icon names here when required by design)
 */
export const ICON_VARIANT = {
  OUTLINE: 'outline',
  FILLED: 'filled'
}

/**
 * Map of icon name (as used in TabsView items) to variant.
 * Icons not listed default to 'outline'.
 */
export const TAB_ICON_VARIANTS_BY_NAME = {
  'deposit-funds': ICON_VARIANT.OUTLINE,
  'withdraw-funds': ICON_VARIANT.OUTLINE,
  bonus: ICON_VARIANT.OUTLINE,
  'bet-history': ICON_VARIANT.OUTLINE,
  'account-info': ICON_VARIANT.OUTLINE,
  'hollow-star': ICON_VARIANT.OUTLINE,
  'menu-limits': ICON_VARIANT.OUTLINE
  // Sample filled icon: 'some-filled-icon': ICON_VARIANT.FILLED
}
